import type { ComponentType } from 'react';
import type { FlowStepId } from '@/types';
import type { StepProps } from '../types';
import { Welcome } from './Welcome';
import { Schedule } from './Schedule';
import { Consent } from './Consent';
import { ConfirmDetails } from './ConfirmDetails';
import { Aadhaar } from './Aadhaar';
import { DocumentCapture } from './DocumentCapture';
import { WaitingRoom } from './WaitingRoom';
import { LiveCall } from './LiveCall';
import { Complete } from './Complete';

/** Registry: which skeleton renders for each flow step. */
export const STEP_COMPONENTS: Record<FlowStepId, ComponentType<StepProps>> = {
  welcome: Welcome,
  schedule: Schedule,
  consent: Consent,
  confirm: ConfirmDetails,
  aadhaar: Aadhaar,
  capture: DocumentCapture,
  waiting: WaitingRoom,
  call: LiveCall,
  complete: Complete,
};
